__turbopack_context__.v({
  "accordion": "singleplancard-module-scss-module__AyxOhq__accordion",
  "accordionCaret": "singleplancard-module-scss-module__AyxOhq__accordionCaret",
  "accordionContent": "singleplancard-module-scss-module__AyxOhq__accordionContent",
  "accordionHideLabel": "singleplancard-module-scss-module__AyxOhq__accordionHideLabel",
  "accordionShowLabel": "singleplancard-module-scss-module__AyxOhq__accordionShowLabel",
  "accordionToggle": "singleplancard-module-scss-module__AyxOhq__accordionToggle",
  "badge": "singleplancard-module-scss-module__AyxOhq__badge",
  "body": "singleplancard-module-scss-module__AyxOhq__body",
  "card": "singleplancard-module-scss-module__AyxOhq__card",
  "channelTiles": "singleplancard-module-scss-module__AyxOhq__channelTiles",
  "cta": "singleplancard-module-scss-module__AyxOhq__cta",
  "ctaContainer": "singleplancard-module-scss-module__AyxOhq__ctaContainer",
  "ctaContainerLeading": "singleplancard-module-scss-module__AyxOhq__ctaContainerLeading",
  "ctaLegal": "singleplancard-module-scss-module__AyxOhq__ctaLegal",
  "desktopOnly": "singleplancard-module-scss-module__AyxOhq__desktopOnly",
  "eyebrow": "singleplancard-module-scss-module__AyxOhq__eyebrow",
  "fadedValueProps": "singleplancard-module-scss-module__AyxOhq__fadedValueProps",
  "feature": "singleplancard-module-scss-module__AyxOhq__feature",
  "featureCheck": "singleplancard-module-scss-module__AyxOhq__featureCheck",
  "featureLabel": "singleplancard-module-scss-module__AyxOhq__featureLabel",
  "features": "singleplancard-module-scss-module__AyxOhq__features",
  "features--bullet": "singleplancard-module-scss-module__AyxOhq__features--bullet",
  "features--checkmark": "singleplancard-module-scss-module__AyxOhq__features--checkmark",
  "flag": "singleplancard-module-scss-module__AyxOhq__flag",
  "hasBorder": "singleplancard-module-scss-module__AyxOhq__hasBorder",
  "leadDetails": "singleplancard-module-scss-module__AyxOhq__leadDetails",
  "listeningOption": "singleplancard-module-scss-module__AyxOhq__listeningOption",
  "listeningOptionAdditional": "singleplancard-module-scss-module__AyxOhq__listeningOptionAdditional",
  "listeningOptionIcon": "singleplancard-module-scss-module__AyxOhq__listeningOptionIcon",
  "listeningOptionText": "singleplancard-module-scss-module__AyxOhq__listeningOptionText",
  "listeningOptionTitle": "singleplancard-module-scss-module__AyxOhq__listeningOptionTitle",
  "listeningOptions": "singleplancard-module-scss-module__AyxOhq__listeningOptions",
  "listeningOptionsLabel": "singleplancard-module-scss-module__AyxOhq__listeningOptionsLabel",
  "listeningOptionsList": "singleplancard-module-scss-module__AyxOhq__listeningOptionsList",
  "longDescription": "singleplancard-module-scss-module__AyxOhq__longDescription",
  "mobileOnly": "singleplancard-module-scss-module__AyxOhq__mobileOnly",
  "offerDetails": "singleplancard-module-scss-module__AyxOhq__offerDetails",
  "partialStaticDetails": "singleplancard-module-scss-module__AyxOhq__partialStaticDetails",
  "seeMore": "singleplancard-module-scss-module__AyxOhq__seeMore",
  "seemoreWrapper": "singleplancard-module-scss-module__AyxOhq__seemoreWrapper",
  "singleCard": "singleplancard-module-scss-module__AyxOhq__singleCard",
  "staticDetails": "singleplancard-module-scss-module__AyxOhq__staticDetails",
  "staticDetailsTruncated": "singleplancard-module-scss-module__AyxOhq__staticDetailsTruncated",
  "staticDetailsWithTopSpacing": "singleplancard-module-scss-module__AyxOhq__staticDetailsWithTopSpacing",
  "subhead": "singleplancard-module-scss-module__AyxOhq__subhead",
  "textAboveCta": "singleplancard-module-scss-module__AyxOhq__textAboveCta",
  "themePink": "singleplancard-module-scss-module__AyxOhq__themePink",
  "themeSxmBlue": "singleplancard-module-scss-module__AyxOhq__themeSxmBlue",
  "title": "singleplancard-module-scss-module__AyxOhq__title",
  "titleAccent": "singleplancard-module-scss-module__AyxOhq__titleAccent",
  "whiteText": "singleplancard-module-scss-module__AyxOhq__whiteText",
  "wrapper": "singleplancard-module-scss-module__AyxOhq__wrapper",
});
